export const SCREEN_NAME_PATTERN = '[A-Za-z][A-Za-z0-9_]{2,15}';

export function getScreenNameHint(screenName, { required = true } = {}) {
  if (!screenName) return required ? '3-16 characters required' : null;
  if (screenName.length < 3) return '3-16 characters required';
  if (screenName.length > 16) return 'Too long (max 16)';
  if (!/^[a-zA-Z]/.test(screenName)) return 'Must start with a letter';
  if (!/^[a-zA-Z0-9_]+$/.test(screenName)) return 'Letters, numbers, and underscores only';
  return null;
}
